import styled from '@emotion/styled';
import { themeVars } from '@eds-web/react';
import { device } from '../../constants/breakpoint';

export const StyledGuardianInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin: 64px auto;
    padding: 32px;
    width: 560px;
    background-color: ${themeVars.color.background.elevated.low};
    border-radius: 24px;
    box-sizing: border-box;
    .form-column {
        display: flex;
        gap: 20px;

        & > div {
            flex: 1;
        }

        .empty-class {
            visibility: hidden;
        }
    }
    @media screen and ${device.laptop} {
        max-width: 100%;
    }
`;
